<template>
  <div>
    <div v-if="showLoadingSpinner" class="fullScreenLoader">
      <v-overlay :value="isOverlayVisible">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </v-overlay>
    </div>
    <v-dialog v-model="showSwitcherModal" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <div class="switcher" v-bind="attrs" v-on="on">
          <div>
            {{ `${selectedPractice && selectedPractice.text}` }}
          </div>
          <div class="switchButton">
            <i class="mdi mdi-sync"></i>
          </div>
        </div>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">
            <span>
              Switch Clinic
            </span>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select v-model="selectedPracticeId"
                          :items="practiceOptions"
                          label="Select a Clinic"
                          required
                          :error="!selectedPracticeId" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" text @click="_close">
            Cancel
          </v-btn>
          <v-btn color="primary"
                 text
                 @click="_switchPractice">
            Switch
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ notification }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  /* eslint-disable */
  import store from "../../../../store";
  import Api from "../../../shared-module/api";

  export default {
    name: "ClinicSwitcher",
    components: {},
    props: {},
    data: () => ({
      showSwitcherModal: false,
      showLoadingSpinner: false,
      snackbar: false,
      notification: "Default message",
      selectedPracticeId: "",
      selectedPractice: null,
      practiceOptions: [],
    }),
    created() {
      this._initializeSwitcher();
    },
    methods: {
      async _initializeSwitcher() {
        this.showLoadingSpinner = true;
        try {
          // Fetch list of practices from API for current user
          const { data: allPractices } = await Api.practice.private.fetchAllUserPractices();

          if (allPractices && allPractices.length) {
            allPractices.forEach((practice) => {
              console.log(practice.Practice_ID);
            });
          }

          // Create an array of objects from the API response matching the expections of the 'v-select' component
          // Populates the select box in the clinic switcher
          this.practiceOptions = allPractices.map(c => ({
            text: c.Company,
            value: c.Practice_ID,
            meta: c
          }));

          this.selectedPracticeId = this.practiceOptions[0].value;
          this._switchPractice();
        } catch (error) {
          console.log('error :>> ', error);

          // Show error notification if API call to fetch practices fails
          this.notification = 'Unable to fetch the list of practices';
          this.snackbar = true;
          this.showLoadingSpinner = false;
        }
        this.showLoadingSpinner = false;
      },
      _switchPractice() {
        this.showSwitcherModal = false;
        this.selectedPractice = this.practiceOptions.find(c => c.meta.Practice_ID === this.selectedPracticeId);

        // Set the selected practice in the vuex data store for reference in other parts of the application
        store.commit("SET_POS_PRACTICE", { practice: this.selectedPractice });
        store.commit("SET_PRACTICE", { practice: this.selectedPractice });
      },
      _close() {
        this.showSwitcherModal = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .switcher {
    min-width: 150px;
    margin-right: 20px;
    margin-top: -6px;
    height: 30px;
    border-radius: 4px;
    box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
    background-color: rgb(0, 166, 95);
    display: flex;
    cursor: pointer;
    justify-content: flex-start;
    align-items: center;
    padding: 0 60px 0 20px;
    color: white;
    position: relative;

    .switchButton {
      position: absolute;
      right: -5px;
      box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.3);
      top: -6px;
      width: 40px;
      height: 40px;
      display: flex;
      font-size: 1.5rem;
      justify-content: center;
      align-items: center;
      padding-top: 2px;
      border-radius: 40px;
      color: rgb(0, 166, 95);
      background-color: white;
    }
  }

  .fullScreenLoader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 1000000 !important;
    height: 100vh;

    .v-overlay--active {
      background-color: white;

      .v-overlay__scrim {
        z-index: 1000000 !important;
      }

      z-index: 1000000 !important;
      background-color: white;
      width: 100vw;
      height: 100vh;
    }
  }
</style>
